import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { favoritesStore } from 'widgets/avia/favorites'

import { Button } from 'shared/ui/button'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import s from './styles.module.scss'

export const FavoritesRemoveModal = () => {
  const { t } = useTranslation()
  const { closeDialog } = useDialogBottomSheet()

  const onClickRemove = async () => {
    await favoritesStore.removeAllFavorites()
    closeDialog()
  }

  return (
    <div className={s.container}>
      <div className={s.info}>
        <p className={clsx('bold-20', s.title)}>
          {t('favorites_block.remove_modal.title')}
        </p>
        <p className={clsx('regular-14', s.text)}>
          {t('favorites_block.remove_modal.subtitle')}
        </p>
      </div>

      <div className={s.buttons}>
        <Button
          className={s.btn}
          borderRadius="md"
          onClick={onClickRemove}
        >
          {t('favorites_block.clean')}
        </Button>
        <Button
          className={s.btn}
          variant={'transparentBlue'}
          onClick={closeDialog}
        >
          {t('favorites_block.cancel')}
        </Button>
      </div>
    </div>
  )
}
